import { ComponentType, LazyExoticComponent, lazy } from 'react';

/**
 * A function to retry loading a chunk to avoid chunk load error for out of date code
 * @param componentImport
 * @param name
 * @returns
 */

export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  name = 'lazy'
  // Return type compatible with react-router v5's component prop
): LazyExoticComponent<T> & ComponentType<unknown> {
  return lazy(() => lazyRetry(componentImport, name)) as LazyExoticComponent<T> & ComponentType<unknown>;
}

function lazyRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  name = 'lazy'
): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem(`retry-${name}-refreshed`) || 'false');

    componentImport()
      .then((component) => {
        window.sessionStorage.setItem(`retry-${name}-refreshed`, 'false');
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          window.sessionStorage.setItem(`retry-${name}-refreshed`, 'true');
          window.location.reload();
          return;
        }
        reject(error);
      });
  });
}
